/**
 * Similar to @see Math.precision with the only difference that you set the precision digits after comma
 *
 * @param value the number value to round
 * @param digitsAfterComma the number of digits retained after comma
 * @returns the rounded number value
 */
export function roundToPrecision(value: number, digitsAfterComma: number): number {
  if (digitsAfterComma < 0 || digitsAfterComma > 100) {
    throw RangeError('roundToPrecision() argument must be between 1 and 100')
  }
  const precisionMultiplier = Math.pow(10, Math.floor(digitsAfterComma))

  return Math.round(value * precisionMultiplier) / precisionMultiplier
}

export function isDiffWithinTolerance(a: number, b: number, tolerance: number): boolean {
  return Math.abs(a - b) < tolerance
}

export function calculatePercentage(full: number, partial: number): number {
  return (partial * 100) / full
}
